import { render, staticRenderFns } from "./sitepages-layout.vue?vue&type=template&id=2f0c4db3"
import script from "./sitepages-layout.vue?vue&type=script&lang=js"
export * from "./sitepages-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/sitepages-layout.vue
// module id = O8eB
// module chunks = 0